exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav{background-color:#fff;-webkit-box-shadow:0 1px 1px rgba(0, 0, 0, .1);box-shadow:0 1px 1px rgba(0, 0, 0, .1);position:fixed;top:0;width:100%;height:70px;z-index:99}nav .title{font-size:1.1em;margin:20px auto;float:none;display:block;width:195px}nav .title a,nav .title a:visited{text-decoration:none;color:#000}nav mat-icon{width:195px;height:40px}", ""]);

// exports
